<template>
    <div class="hh-password-wrapper hh-input-label-wrapper">
       <label :for="componentId" v-if="withLabel || !enabled" class="hh-input-label">{{label}}</label>
        <div class="hh-password-container form-control card-number-wrapper"
             :class="cssClassContainer">

         <div class="hh-password-icon-container password d-flex">
           <img src="/dist/site/static/icons/lock.svg" alt="lock">
          </div>
          
            <input :type="inputType" class="form-control hh-password-input"
                   :class="allCssClassesInput"
                   v-on:input="$emit('input', $event.target.value)"
                   :autocomplete="autocomplete"
                   :maxlength='maxlength'
                   :required="required"
                   :id="componentId"
                   @focus="enabled = true"
                   @blur="enabled = false"
                   :placeholder="placeholder"
            >
         
            <div class="hh-password-icon-container visibility" @click="visibility = !visibility">
                <!--            <i v-if="!visibility" class="fa fa-eye" aria-hidden="true"></i>-->
                <!--            <i v-if="visibility"  class="fa fa-eye-slash" aria-hidden="true"></i>-->
                <font-awesome-icon  v-if="!visibility" icon="eye-slash" class="eye"/>
                <font-awesome-icon  v-if="visibility" icon="eye" class="eye"/>
            </div>
        </div>
        <div class="form-group" v-if="showHint && role === 'organizer'">
            <div class="hint-text-green">Password should contain at least 8 characters, one lowercase letter, one uppercase letter and  one number.</div>
        </div>
        <div class="form-group" v-else-if="showHint && role !== 'organizer'">
            <div class="hint-text-green">Password should contain at least 8 characters.</div>
        </div>
       
    </div>

</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    name: 'PasswordContainer',

    components: {
      'font-awesome-icon': FontAwesomeIcon
    },

    props: {
      id: {
        type: String,
      },
      cssClassContainer: String,
      cssClassInput: String,
      value: String,
      autocomplete: String,
      placeholder: String,
      label: String,
      role: String,
      maxlength: {
        type: Number,
        default: 30,
      },
      required: {
        type: Boolean,
        default: false,
      },
      showHint: {
        type: Boolean,
        default: true,
      },
      withLabel: {
        type: Boolean,
        default: true,
      },
    },

    data: () => {
      return {
        enabled: false,
        visibility: false,
      }
    },

    computed: {
      inputType () {
        if (this.visibility) {
          return 'text'
        }

        return 'password'
      },
      allCssClassesInput () {
        let result = this.cssClassInput

        if (!_.isEmpty(this.value)) {
          result += " hh-label-active"
        }

        return result
      },
      componentId () {
        if (this.id == null) {
         return `input-label-${this._uid}`
        }
        return this.id
      },

      
    },

  }
</script>

<style lang="scss" scoped>
	.svg.eye {
		margin-bottom: 5px;
	}
  
  .password.hh-password-icon-container {
    color: #9A9A9A; line-height: 2.6; margin-right: 15px;
  }

  .visibility.hh-password-icon-container {
    color: #9A9A9A;
  }

  .eye {
    width: 16px !important;
  }

  .hint-text-green {
    color: #4ACD8D; 
    font-size: 14px;
    line-height: 14px;
    margin-top: 11px;
  }

   .hh-password-container {
    display: flex;
    justify-content: flex-end;

    .hh-password-input {
      width: 100%;
      border: none;
      padding: 0;
      box-shadow: none;
      background: none;
    }

    .hh-password-icon-container {
      cursor: pointer;
      line-height: 2.6;
    }

    @media screen and (max-width: 991px ) {
      .hh-password-icon-container {
        margin-right: 5px;
      }

      .hh-password-input {
       font-size: 14px;
      }

      .hint-text {
        margin-left: -15px;
      }
    }
  }
</style>